import React from "react";
import { XCircleIcon, CheckCircle2Icon, ArrowDownIcon } from "lucide-react";
import { beforeItems, afterItems } from "../../data/landing";
import { SectionHeading } from "../SectionHeading";
import { TransformCta } from "../TransformCta";
export function BeforeAfter() {
  return <section className="bg-white px-5 py-16" data-id="element-73" data-mp="22l15fiutlnj1">
      <SectionHeading eyebrow="Before & After" title={<>
            From scattered information to a <em className="text-brand" data-id="element-75" data-mp="2z8xm0nq9ciu9">structured clinical workflow</em>
          </>} data-id="element-74" data-mp="22mc6hawvsh6g" />
      <div className="mx-auto mt-10 grid max-w-5xl items-stretch gap-5 md:grid-cols-2" data-id="element-76" data-mp="2u9ufeyumq4k6">
        <div className="rounded-3xl border-2 border-alert/25 bg-red-50 p-6" data-id="element-77" data-mp="2q8ipes7ufhbg">
          <span className="inline-block rounded-full bg-alert px-4 py-1.5 text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-78" data-mp="2lah4e1qux7xc">
            Before
          </span>
          <h3 className="mt-4 font-serif text-2xl font-extrabold text-ink" data-id="element-79" data-mp="19vkdemb448nc">Before Diabetes Clinical Blueprint</h3>
          <p className="mt-1 text-muted" data-id="element-80" data-mp="17546q3dfeu46">You may recognize some of these situations:</p>
          <ul className="mt-5 space-y-3.5" data-id="element-81" data-mp="1c4yy08145lpr">
            {beforeItems.map(t => <li key={t} className="flex gap-3 text-[16px] leading-snug text-ink" data-id="element-82" data-mp="y4xz2y4esocx">
                <XCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-alert" aria-hidden="true" data-id="element-83" data-mp="133r37zxt330f" />
                <span data-id="element-84" data-mp="135lml9tfin2e">{t}</span>
              </li>)}
          </ul>
        </div>

        <div className="flex justify-center md:hidden" aria-hidden="true" data-id="element-85" data-mp="od1owop1t7sc">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-navy text-white" data-id="element-86" data-mp="t760jl99e3zr">
            <ArrowDownIcon className="h-5 w-5" data-id="element-87" data-mp="fg140s16trtn" />
          </span>
        </div>

        <div className="rounded-3xl border-2 border-cta/30 bg-green-50 p-6" data-id="element-88" data-mp="jgl3i298h7iy">
          <span className="inline-block rounded-full bg-cta px-4 py-1.5 text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-89" data-mp="5fqpn43f2ecw">
            After
          </span>
          <h3 className="mt-4 font-serif text-2xl font-extrabold text-ink" data-id="element-90" data-mp="2c497ofcpsnfq">With Diabetes Clinical Blueprint</h3>
          <p className="mt-1 text-muted" data-id="element-91" data-mp="27dstgt12kxsb">A structured reference collection designed to help you:</p>
          <ul className="mt-5 space-y-3.5" data-id="element-92" data-mp="23bpgfzyr5l4x">
            {afterItems.map(t => <li key={t} className="flex gap-3 text-[16px] leading-snug text-ink" data-id="element-93" data-mp="1ycuoo8it4m8o">
                <CheckCircle2Icon className="mt-0.5 h-6 w-6 shrink-0 text-cta" aria-hidden="true" data-id="element-94" data-mp="1yarqv2bexote" />
                <span data-id="element-95" data-mp="2v10x76iunys8">{t}</span>
              </li>)}
          </ul>
        </div>
      </div>
      <TransformCta label="Yes, I want a clearer clinical workflow" data-id="element-96" data-mp="2qzp6sys5j9iz" />
    </section>;
}